module.exports = __webpack_public_path__ + "img/system19-details.b92ef20d.png";